export default __webpack_public_path__ + "static/media/oruga.8a9f0206.png";